"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmeraldBadgeCoreInputs = void 0;
const badge_size_1 = require("./badge.size");
class EmeraldBadgeCoreInputs {
    constructor() {
        this.disabled = false;
        this.size = badge_size_1.EmeraldBadgeSize.SMALL;
        this.variant = badge_size_1.EmeraldBadgeVariant.DOT;
        this.position = 'top-right';
        this.hide = false;
    }
}
exports.EmeraldBadgeCoreInputs = EmeraldBadgeCoreInputs;
//# sourceMappingURL=badge.inputs.js.map